import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ChevronDown, ChevronUp } from '../../../Common/SvgIcon/CommonSvgIcons';
import { IoClose } from 'react-icons/io5';

const DropdownContainer = styled.div`
  position: relative;
  width: 430px;
`;

const DropdownHeader = styled.div`
  color: var(--Body, #2a2929);
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const DropdownList = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const Option = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 15px;
  input {
    accent-color: #2d8955;
  }
`;

const CountWrapper = styled.div`
  background-color: #2d8955;
  display: flex;
  gap: 8px;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  padding: 6px;
  align-items: center;
  width: 30px;
`;

const ButtonContainer = styled.button`
  border: none;
  background: none;
  padding: unset;
  padding-top: 2px;
`;

const FilterDropDown = ({
  title = 'Select Items',
  options = [],
  onChange,
  resetTrigger,
  isOpen,
  onToggle,
  selectedOptions,
}) => {
  const [selected, setSelected] = useState([]);

  const toggleOption = (option) => {
    let updated;
    if (selected.includes(option)) {
      updated = selected.filter((item) => item !== option);
    } else {
      updated = [...selected, option];
    }
    setSelected(updated);
    if (onChange) onChange(updated);
  };
  useEffect(() => {
    if (Array.isArray(selectedOptions)) {
      setSelected(selectedOptions);
    }
  }, [selectedOptions]);

  useEffect(() => {
    setSelected([]);
    if (onChange) onChange([]);
  }, [resetTrigger]);

  return (
    <DropdownContainer>
      <DropdownHeader onClick={onToggle}>
        <div>{title}</div>
        <div style={{ display: 'flex', gap: '20px' }}>
          {selected?.length > 0 && (
            <CountWrapper>
              <div>{selected?.length}</div>
              <ButtonContainer
                onClick={(e) => {
                  e.stopPropagation(); // Prevent closing dropdown when clearing
                  setSelected([]);
                  onChange([]);
                }}
              >
                <IoClose color='#ffffff' />
              </ButtonContainer>
            </CountWrapper>
          )}
          <div>{isOpen ? ChevronUp : ChevronDown}</div>
        </div>
      </DropdownHeader>

      {isOpen && (
        <DropdownList>
          {options.map((option) => (
            <>
              <Option key={option}>
                <input
                  type='checkbox'
                  checked={selected?.includes(option?.toLowerCase())}
                  onChange={() => toggleOption(option?.toLowerCase())}
                />
                {option}
              </Option>
            </>
          ))}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};

export default FilterDropDown;
